// React libraries
import React, { useState, useEffect } from "react";
// Custom Styles
import { useStyles } from "./InventoryCountingExpectedItemsPageStyles";
// Material-UI Core
import { Grid } from "@mui/material";
import BlueGradientHeader from "../BlueGradientHeader";
import PageWrapper from "../PageWrapper";
import GreyButton from "../GreyButton";
import ScanContentBar from "../ScanContentBar";
import WarningModal from "../WarningModal";
import Close from "../../../icons/Close/Close";
export const InventoryCountingExpectedItemsPage = (props) => {
    const classes = useStyles(props);
    const { previewWidth, previewHeight, data, scanContentBarText, isListPrefilled, isConfirmNeeded } = props;
    const [itemList, setItemList] = useState(data);
    useEffect(() => {
        setItemList(data);
    }, [data]);
    const removeItem = (itemData) => {
        setItemList(itemList.filter((e) => (e !== itemData)));
    };
    return (React.createElement(PageWrapper, { previewHeight: previewHeight, previewWidth: previewWidth },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, md: 12 },
                React.createElement(BlueGradientHeader, { type: "smallWithSub", showScanner: true, previewHeight: previewHeight },
                    React.createElement("p", null, "Inventory Counting"),
                    React.createElement("sub", null,
                        "Bin Location - ",
                        React.createElement("b", null, "05-G01-R01-P03")))),
            React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentTopRadius, style: { height: previewHeight - 90 - 40 } },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(ScanContentBar, { text: scanContentBarText || InventoryCountingExpectedItemsPage.defaultProps.scanContentBarText })),
                    React.createElement(Grid, { item: true, md: 12, className: classes.textInputBox },
                        React.createElement("span", null, "Enter Manually")),
                    React.createElement(Grid, { container: true, className: classes.headerContentBar },
                        React.createElement("span", null,
                            React.createElement("b", null, "Item")),
                        React.createElement("span", null,
                            React.createElement("b", null, "Counted Quantity"))),
                    React.createElement(Grid, { item: true, md: 12, className: classes.greyContentPlain, style: { height: previewHeight - 90 - 40 - 40 - 70 } }, isListPrefilled ?
                        React.createElement(Grid, { container: true }, itemList.length > 0 &&
                            itemList.map((data) => (React.createElement(React.Fragment, null,
                                React.createElement(Grid, { item: true, md: 12, className: classes.whiteContentBarWithCloseButton },
                                    React.createElement(Grid, { className: classes.blackLeftContent, item: true, xs: 5, style: { alignSelf: "center", overflow: "hidden", textOverflow: "ellipsis" } }, data.itemName),
                                    React.createElement(Grid, { className: classes.blackRightContent, item: true, xs: 5 }, data.currentQuantity + " / " + data.expectedQuantity + " pc"),
                                    React.createElement(Grid, { item: true, xs: 2 },
                                        React.createElement(Close, { className: classes.whiteContentBarCloseButton, onClick: () => { removeItem(data); } }))),
                                React.createElement(Grid, { item: true, md: 12, className: classes.ContentBorder })))))
                        :
                            React.createElement(Grid, { container: true, justifyContent: "center", className: classes.noContentBar },
                                React.createElement("span", null,
                                    React.createElement("b", null, "Please Scan Item")))))),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "left" }, "Cancel")),
            React.createElement(Grid, { item: true, md: 6 },
                React.createElement(GreyButton, { onClick: () => { }, type: "right" }, "Confirm"))),
        React.createElement(WarningModal, { modalType: "doubleOption", isModalOpen: isConfirmNeeded, data: { message: "Do you want to use Rainbow Fotopapier for new position?" } })));
};
InventoryCountingExpectedItemsPage.defaultProps = {
    scanContentBarText: "Please scan Item..."
};
export default React.memo(InventoryCountingExpectedItemsPage);
